"use strict";

var e = require("@web3-react/abstract-connector");

function t() {
  return (t = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function r(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}

function n(e) {
  return (n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function o(e, t) {
  return (o = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function i() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function c(e, t, r) {
  return (c = i() ? Reflect.construct : function (e, t, r) {
    var n = [null];
    n.push.apply(n, t);
    var i = new (Function.bind.apply(e, n))();
    return r && o(i, r.prototype), i;
  }).apply(null, arguments);
}

function u(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return (u = function u(e) {
    if (null === e || -1 === Function.toString.call(e).indexOf("[native code]")) return e;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, r);
    }

    function r() {
      return c(e, arguments, n(this).constructor);
    }

    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), o(r, e);
  })(e);
}

function a(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function h(e, t) {
  try {
    var r = e();
  } catch (e) {
    return t(e);
  }

  return r && r.then ? r.then(void 0, t) : r;
}

function s(e) {
  return e.hasOwnProperty("result") ? e.result : e;
}

require("tiny-warning"), "undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))), "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));

var d = function (e) {
  function t() {
    var t;
    return (t = e.call(this) || this).name = t.constructor.name, t.message = "No Ethereum provider was passed to the constructor or found on window.ethereum.", t;
  }

  return r(t, e), t;
}(u(Error)),
    f = function (e) {
  function t() {
    var t;
    return (t = e.call(this) || this).name = t.constructor.name, t.message = "The user rejected the request.", t;
  }

  return r(t, e), t;
}(u(Error)),
    p = function (e) {
  function n(t) {
    var r,
        n = t.provider,
        o = void 0 === n ? window.ethereum : n;
    return (r = e.call(this, {
      supportedChainIds: t.supportedChainIds
    }) || this).provider = o, r.handleNetworkChanged = r.handleNetworkChanged.bind(a(r)), r.handleChainChanged = r.handleChainChanged.bind(a(r)), r.handleAccountsChanged = r.handleAccountsChanged.bind(a(r)), r.handleClose = r.handleClose.bind(a(r)), r;
  }

  r(n, e);
  var o = n.prototype;
  return o.handleChainChanged = function (e) {
    this.emitUpdate({
      chainId: e,
      provider: this.provider
    });
  }, o.handleAccountsChanged = function (e) {
    0 === e.length ? this.emitDeactivate() : this.emitUpdate({
      account: e[0]
    });
  }, o.handleClose = function (e, t) {
    this.emitDeactivate();
  }, o.handleNetworkChanged = function (e) {
    this.emitUpdate({
      chainId: e,
      provider: this.provider
    });
  }, o.activate = function () {
    try {
      var e,
          r = function r(_r) {
        if (n) return _r;

        function i() {
          return t({
            provider: o.provider
          }, e ? {
            account: e
          } : {});
        }

        var c = function () {
          if (!e) return Promise.resolve(o.provider.enable().then(function (e) {
            return e && s(e)[0];
          })).then(function (t) {
            e = t;
          });
        }();

        return c && c.then ? c.then(i) : i();
      },
          n = !1,
          o = this;

      if (!o.provider) throw new d();
      o.provider.on && (o.provider.on("chainChanged", o.handleChainChanged), o.provider.on("accountsChanged", o.handleAccountsChanged), o.provider.on("close", o.handleClose), o.provider.on("networkChanged", o.handleNetworkChanged)), o.provider.isMetaMask && (o.provider.autoRefreshOnNetworkChange = !1);
      var i = h(function () {
        return Promise.resolve(o.provider.send("eth_requestAccounts").then(function (e) {
          return s(e)[0];
        })).then(function (t) {
          e = t;
        });
      }, function (e) {
        if (4001 === e.code) throw new f();
      });
      return Promise.resolve(i && i.then ? i.then(r) : r(i));
    } catch (e) {
      return Promise.reject(e);
    }
  }, o.getProvider = function () {
    try {
      return Promise.resolve(this.provider);
    } catch (e) {
      return Promise.reject(e);
    }
  }, o.getChainId = function () {
    try {
      var e,
          t = function t() {
        function t() {
          if (!e) try {
            e = s(r.provider.send({
              method: "net_version"
            }));
          } catch (e) {}
          return e || (e = r.provider.isDapper ? s(r.provider.cachedResults.net_version) : r.provider.chainId || r.provider.networkVersion || r.provider._chainId), e;
        }

        var n = function () {
          if (!e) {
            var t = h(function () {
              return Promise.resolve(r.provider.send("net_version").then(s)).then(function (t) {
                e = t;
              });
            }, function () {});
            if (t && t.then) return t.then(function () {});
          }
        }();

        return n && n.then ? n.then(t) : t();
      },
          r = this;

      if (!r.provider) throw new d();
      var n = h(function () {
        return Promise.resolve(r.provider.send("eth_chainId").then(s)).then(function (t) {
          e = t;
        });
      }, function () {});
      return Promise.resolve(n && n.then ? n.then(t) : t());
    } catch (e) {
      return Promise.reject(e);
    }
  }, o.getAccount = function () {
    try {
      var e,
          t = function t() {
        function t() {
          return e || (e = s(r.provider.send({
            method: "eth_accounts"
          }))[0]), e;
        }

        var n = function () {
          if (!e) {
            var t = h(function () {
              return Promise.resolve(r.provider.enable().then(function (e) {
                return s(e)[0];
              })).then(function (t) {
                e = t;
              });
            }, function () {});
            if (t && t.then) return t.then(function () {});
          }
        }();

        return n && n.then ? n.then(t) : t();
      },
          r = this;

      if (!r.provider) throw new d();
      var n = h(function () {
        return Promise.resolve(r.provider.send("eth_accounts").then(function (e) {
          return s(e)[0];
        })).then(function (t) {
          e = t;
        });
      }, function () {});
      return Promise.resolve(n && n.then ? n.then(t) : t());
    } catch (e) {
      return Promise.reject(e);
    }
  }, o.deactivate = function () {
    this.provider && this.provider.removeListener && (this.provider.removeListener("chainChanged", this.handleChainChanged), this.provider.removeListener("accountsChanged", this.handleAccountsChanged), this.provider.removeListener("close", this.handleClose), this.provider.removeListener("networkChanged", this.handleNetworkChanged));
  }, o.isAuthorized = function () {
    try {
      var e = this;
      return Promise.resolve(!!e.provider && h(function () {
        return Promise.resolve(e.provider.send("eth_accounts").then(function (e) {
          return s(e).length > 0;
        }));
      }, function () {
        return !1;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }, n;
}(e.AbstractConnector);

exports.NoEthereumProviderError = d, exports.ProvidedConnector = p, exports.UserRejectedRequestError = f;